import { Fragment } from 'react';
import { NavMarker } from 'react-rhumb';
import { useLocation, useParams } from 'react-router-dom';
import MetaRobots from 'marketplace-ui-common/components/elements/MetaRobots';
import DocumentHead from 'marketplace-ui-common/components/portals/DocumentHead';
import PrerenderReady from 'marketplace-ui-common/components/prerender/PrerenderReady';
import PrerenderStatusCode from 'marketplace-ui-common/components/prerender/PrerenderStatusCode';
import getDataFetchingClientStatus from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientErrorStatus';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import HSPageViewTracker from 'marketplace-ui-common/tracking/components/HSPageViewTracker';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { resetThemeSlug, updateThemeSlug } from '../../actions/ThemeDetailsActions';
import GenericError from '../../components/error/GenericError';
import NoAccessError from '../../components/error/NoAccessError';
import NotFoundError from '../../components/error/NotFoundError';
import StorefrontUsageTrackerProvider from '../../context/StorefrontUsageTrackerProvider';
import { useAppDispatch } from '../../reducers';
import { PublicOnly } from '../../selectors/app';
import { getRootUrl } from '../../utils/urls';
import ThemeDetailsPage from '../components/ThemeDetailsPage';
import { useThemeDetails } from '../hooks/useThemeDetails';

// @ts-expect-error untyped import
import { getIsUngatedForUnifiedDetails } from '../../selectors/auth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThemeDetailsError = ({
  children
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(PublicOnly, {
    children: /*#__PURE__*/_jsxs(DocumentHead, {
      children: [/*#__PURE__*/_jsx(MetaRobots, {
        directive: ['nofollow', 'noindex']
      }), /*#__PURE__*/_jsx(PrerenderReady, {}), /*#__PURE__*/_jsx(PrerenderStatusCode, {
        statusCode: 404
      })]
    })
  }), children]
});
export default function ThemeDetailsContainer() {
  const {
    pathname
  } = useLocation();
  const {
    slug
  } = useParams();
  const appDispatch = useAppDispatch();
  const isUngatedForUnifiedDetails = useSelector(getIsUngatedForUnifiedDetails);
  const {
    loading,
    error,
    themeDetails
  } = useThemeDetails({
    slug,
    isUngatedForUnifiedDetails
  });
  const requestState = getDataFetchingClientRequestState(error, loading);
  useEffect(() => {
    appDispatch(updateThemeSlug(slug));
    return () => {
      appDispatch(resetThemeSlug());
    };
  }, [appDispatch, slug]);
  if (error) {
    switch (getDataFetchingClientStatus(error)) {
      case 403:
        {
          return /*#__PURE__*/_jsx(ThemeDetailsError, {
            children: /*#__PURE__*/_jsx(NavMarker, {
              name: "THEME_DETAILS_403_LOAD",
              children: /*#__PURE__*/_jsx(NoAccessError, {})
            })
          });
        }
      case 404:
        {
          return /*#__PURE__*/_jsx(ThemeDetailsError, {
            children: /*#__PURE__*/_jsx(NavMarker, {
              name: "THEME_DETAILS_404_LOAD",
              children: /*#__PURE__*/_jsx(NotFoundError, {})
            })
          });
        }
      default:
        {
          return /*#__PURE__*/_jsx(ThemeDetailsError, {
            children: /*#__PURE__*/_jsx(NavMarker, {
              name: "THEME_DETAILS_ERROR_LOAD",
              children: /*#__PURE__*/_jsx(GenericError, {})
            })
          });
        }
    }
  }
  return /*#__PURE__*/_jsxs(StorefrontUsageTrackerProvider, {
    children: [requestState === 'SUCCEEDED' ? /*#__PURE__*/_jsx(ThemeDetailsPage, {
      themeDetails: themeDetails
    }, `theme-details-${slug}`) : null, /*#__PURE__*/_jsx(HSPageViewTracker, {
      pathname: `${getRootUrl()}${pathname}`
    })]
  });
}